core.constant('subscriptionTranslationPL', {
  "T": {
    "UI": {
      "TABBAR": {
      },
      "BREADCRUMB": {
      }
    },
    "MODULE": {
      "SUBSCRIPTION": {
        "PACKAGE": "Pakiet",
        "PACKAGES": "Pakiety",
        "ACTIVE_FROM": "Ważny od",
        "ACTIVE_UNTIL": "Ważny do",
        "ASSIGNED_TO": "Przypisany do",
        "EXTEND": "Przedłuż",
        "CHANGE_PACKAGE": "Zmień pakiet",
        "RESIGN": "Rezygnuj",
        "ASSIGN_USER": "Przypisz użytkownika",
        "BLOCK_ASSIGNED_USER": "Zablokuj użytkownika",
        "ACTIVE_SUBSCRIPTION": "Obowiazujący pakiet",
        "NUMBER_OF_LICENSES_BOUGHT": "Liczba zakupionych licencji",
        "NO_EXTENDING_FOR_TRIAL": "Nie można przedłużać okresu próbnego",
        "ACTIVE_SUBSCRIPTION_TIME_SPAN": "Okres obowiązywania",
        "NEW_TERM": "Nowy termin",
        "AGREE_AND_PAY": "Akceptuję i płacę",
        "REMOVE_ASSIGNED_USER_CONFIRMATION": "Czy jesteś pewny, że chcesz zablokować wskazanego użytkownika?",
        "ASSIGN_USER_TO_LICENSE": "Przypisz użytkownika do licencji",
        "DOCTOR": "Doktor",
        "NEW_DOCTOR": "Nowy doktor",
        "CHANGE_TO_YEAR": "Zmień na rok",
        "CHANGE_TO_MONTH": "Zmień na miesiąc",
        "CHANGE_TO_BASIC": "Zmień na BASIC",
        "CHANGE_TO_PREMIUM": "Zmień na PREMIUM",
        "ACTIVE_SUBSCRIPTION_FORM": "Wykupiona forma",
        "NO_TOKEN_REDIRECT": "Brak autentykacji dla tego widoku, przekierowanie do strony logowania",
        "ACTIVE_PERIOD": "Obowiązujący okres",
        "CHANGE_PERIOD_FOR_ACTIVE_SUBSCRIPTION": "Zmiana okresu obowiązywania pakietu",
        "CHANGE_TYPE_FOR_ACTIVE_SUBSCRIPTION": "Zmiana pakietu na",
        "CHANGED_SUBSCRIPTION_TO_MONTH": "1 Miesiąc, ważny od",
        "CHANGED_SUBSCRIPTION_TO_YEAR": "1 rok/12 miesięcy, ważny od",
        "LICENSES_COUNT": "Liczba licencji",
        "SUMMARY_PRICE": "RAZEM",
        "TRIAL_SUBSCRIPTION_EXPIRATION_IN_DAYS": "Uprzejmie przypominamy, iż Państawa licencja testowa EDM+ wygasa za",
        "DAYS": "dni",
        "SUBSCRIPTION_EXPIRATION": "Uprzejmie przypominamy, iż Państawa licencja EDM+ wygasa w dniu"
      }
    }
  }
});
